/* raw layout hash: _trade-categories-rate-cards-layout:eb491775f9eeb5ac01206793579867b35f51d66aef2e5c24bfda2359cfa2c0a8 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_trade-categories-rate-cards-layout" — renders its page content through the router outlet.
export default function TradeCategoriesRateCardsLayout() {
  return <AppShell layoutName="_trade-categories-rate-cards-layout" menu={LAYOUT_MENUS['_trade-categories-rate-cards-layout']} />;
}
